import {H1, H2} from './ui/Header';
import protectedRoute from './protectedRoute';
import {useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {API, graphqlOperation} from 'aws-amplify';
import {Form, FormButtons, FormContent, FormPair} from './ui/Form';
import Button from './ui/Button';
import {Card} from './ui/Card';
import {updateCustomer} from '../graphql/mutations';
import FadeSpinner from './ui/FadeSpinner';

const emptyForm = {firstname: '', middlename: '', lastname: '', phone: ''}

function Account() {
  const [formState, setFormState] = useState(emptyForm)
  const user = useSelector(state => state.user.currentUser)
  const [customer, setCustomer] = useState()

  useEffect(() => {
    // Fetch customer data based on logged in user ID
    const fetchCustomer = async() => {
      const response = await API.graphql(graphqlOperation(`query customerByUserID {
          customerByUserID(userID: "${user.id}") {
            items {          
              id
              userID
              username
              firstname
              middlename
              phone
              lastname
              number
            }
          }
        }`))
      return response.data.customerByUserID.items[0]
    }

    if(user) {
      fetchCustomer()
        .then((response) => {
          console.log(response)
          setCustomer(response)
          setFormState({firstname: response.firstname, lastname: response.lastname, phone: response.phone,
            middlename: response.middlename})
        })
    }
  }, [user])

  function setInput(key, value) {
    // Automatically add dashes as phone numbers are typed
    if(key === 'phone') {
      if(value.length === 3 && formState.phone.length === 2) {
        value += '-'
      } else if(value.length  === 7 && formState.phone.length === 6) {
        value += '-'
      }
    }
    setFormState({ ...formState, [key]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await API.graphql(graphqlOperation(updateCustomer, {input :
        {id: customer.id, userID: customer.userID, firstname: formState.firstname, middlename: formState.middlename, lastname: formState.lastname,
          phone: formState.phone}}))
  }

  return (
    <>
      <H1>Account</H1>
      {customer ?
        <Card maxWidth='800px'>
          <H2>Update Account Information</H2>
          <Form onSubmit={handleSubmit}>
            <FormContent>
              <FormPair>
                <label>First Name:</label>
                <input
                  type='text'
                  onChange={event => setInput('firstname', event.target.value)}
                  value={formState.firstname}
                />
              </FormPair>
              <FormPair>
                <label>Middle Name:<br/>(Optional)</label>
                <input
                  type='text'
                  onChange={event => setInput('middlename', event.target.value)}
                  value={formState.middlename}
                />
              </FormPair>
              <FormPair>
                <label>Last Name:</label>
                <input
                  type='text'
                  onChange={event => setInput('lastname', event.target.value)}
                  value={formState.lastname}
                />
              </FormPair>
              <FormPair color='text'>
                <label>Phone number:<br/><small>Eg : 081 222 2224 </small></label>
                <input
                  type="tel"
                  onChange={event => setInput('phone', event.target.value)}
                  value={formState.phone}
                  placeholder="888-888-8888"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  maxLength="12"
                  title="888-888-8888" required/>
              </FormPair>
            </FormContent>
            <FormButtons>
              <Button type='submit'>Submit</Button>
            </FormButtons>
          </Form>
        </Card>
        :
        <FadeSpinner/>
      }
    </>
  )
}

export default protectedRoute(Account)